import React from 'react';
import './style.css';
import Typography from '@material-ui/core/Typography';
import ClosedCookie from '../../../assets/images/fortuneCookie/closedCookie.webp';
import OpenCookie from '../../../assets/images/fortuneCookie/openedCookie.webp';
import { sendData } from '../../../../analytics/sendData';
import { FormattedMessage } from 'react-intl';

class FortuneCookie extends React.Component{
    state = {
        showOpenCookie: false,
        showQuote: <FormattedMessage id="q0"
        defaultMessage="True happiness makes us wise."
    />,
        quote0: <FormattedMessage id="q0"
                                    defaultMessage="True happiness makes us wise."
                                />,
        quote1: <FormattedMessage id="q1"
                                    defaultMessage="Just have fun."
                                />,
        quote2: <FormattedMessage id="q2"
                                    defaultMessage="Tomorrow is another day."
                                />,
        quote3: <FormattedMessage id="q3"
                                    defaultMessage="To be idle is to be foolish."
                                />,

        quote4: <FormattedMessage id="q4"
                                    defaultMessage="Learn how to do something new today."
                                />,
        quote5: <FormattedMessage id="q5"
                                    defaultMessage="Do your job to the best of your ability."
                                />,
        quote6: <FormattedMessage id="q6"
                                    defaultMessage="Fame and fortune lie ahead."
                                />,
        quote7: <FormattedMessage id="q7"
                                    defaultMessage="Be thankful, even if your life is not perfect."
                                />,

        quote8: <FormattedMessage id="q8"
                                    defaultMessage="Face the truth with dignity."
                                />,
        quote9: <FormattedMessage id="q9"
                                    defaultMessage="Everything will workout for the best."
                                />,
        quote10: <FormattedMessage id="q10"
                                    defaultMessage="True love is on the way. Make room!"
                                />,
        quote11: <FormattedMessage id="q11"
                                    defaultMessage="Your smile lights up other people."
                                />,

        quote12: <FormattedMessage id="q12"
                                    defaultMessage="If you can dream it, you can become it!"
                                />,
        quote13: <FormattedMessage id="q13"
                                    defaultMessage="Things may seem much worse than they are."
                                />,
        quote14: <FormattedMessage id="q14"
                                    defaultMessage="Trust your friends but keep your eyes open."
                                />,
        quote15: <FormattedMessage id="q15"
                                    defaultMessage="It may be difficult, but it will be worth it in the end."
                                />,
         
        quote16: <FormattedMessage id="q16"
                                    defaultMessage="Fall for someone who is not your type."
                                />
    }

    componentDidMount() {
        sendData('', 'fortune cookie' , 'viewed');
    }

    changeCookieStatus = () => {
        this.setState({showOpenCookie: !this.state.showOpenCookie});
        sendData('', 'fortune cookie' , 'engaged');
    }
    changeCookieStatusFinal = () => {
        let min = Math.ceil(0);
        let max = Math.floor(16);
        let randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

        let quote = 'quote' + randomNumber;
        
        this.setState({showQuote: this.state[quote]});
        sendData('', 'fortune cookie' , 'engaged');
    }
    render() {
    return (
        <div>
                <div component="p" style={{display: 'flex', justifyContent: 'center', letterSpacing: '0.05em',
                                            color: '#e0515d', marginTop: '100px', marginBottom: '20px',
                                            fontSize: '45px', fontFamily: 'balthazar,serif'}}>
                    <FormattedMessage id="games"
                                    defaultMessage="Games"
                                />
                </div>
                <div style={{width: '25%'}}>
                </div>
                <div component="p" style={{ textAlign: 'center', color: '#fefefe',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.7rem',
                                            fontWeight: '400', width: '100%',minWidth:'320px',
                                            maxWidth:'640px', left: '50%', transform: 'translateX(-50%)', position: 'relative' ,
                                            }}>
                    <FormattedMessage id="cookiedesc"
                                    defaultMessage="Everyone loves cracking open a fortune cookie at the end of a meal... Now you can open as many as you want!"
                                />
                </div>
                <div style={{width: '25%'}}>
                </div>
                <Typography style={{display: 'flex', justifyContent: 'center', 
                                    marginBottom: '20px', fontSize: '2rem',
                                    fontWeight: '350', letterSpacing: '.02em',
                                    textTransform: 'uppercase', fontFamily: 'khand,sans-serif', 
                                    marginTop: '20px', color: '#e0515d'}}>
                    <h3><FormattedMessage id="askthefortunecookie"
                                    defaultMessage="ASK THE FORTUNE COOKIE"
                                /></h3>
                </Typography>
                <div style={{width: '25%'}}>
                </div>
                
                <div style={{display:'flex', justifyContent: 'center'}}>                   
                    {this.state.showOpenCookie ? 
                                <div style={{ position: 'relative' }}>
                                    <img src={OpenCookie} style={{height: '250px'}}/>
                                    <p className={'fortuneCookie'} style={{position: 'absolute', margin: '0px',
                                                top: '32%', left: '50%', right: '7%', textAlign: 'left', color: 'black'}}>
                                                {this.state.showQuote}</p>
                                </div>
                                :
                                <p><img src={ClosedCookie} style={{height: '250px'}}/></p>}
                </div>

                <div style={{display: 'flex', color: '#fefefe', backgroundColor: 'transparent',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem', justifyContent: 'center',
                                            fontWeight: '450', width: '50%', left: '25%',
                                            textAlign: 'center', position: 'relative' 
                                }}>
                    <div style={{marginBottom: '25px'}}>                
                        {this.state.showOpenCookie ? 
                        <button style={{lineHeight: '2', letterSpacing: '0.05em'}} className={'btn btn-danger btn-lg'} onClick={this.changeCookieStatusFinal}><FormattedMessage id="crackano"
                        defaultMessage="CRACK ANOTHER COOKIE"
                    /></button>  
                        :
                        <button style={{lineHeight: '2', letterSpacing: '0.05em'}} className={'btn btn-danger btn-lg'} onClick={this.changeCookieStatus}><FormattedMessage id="opencookie"
                        defaultMessage="OPEN THE COOKIE"
                    /></button>
                        }      
                    </div>
                </div>
        </div>
        )
    }
}

export default FortuneCookie;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/games/fortuneCookies.js